import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { FaAngleLeft } from '@react-icons/all-files/fa/FaAngleLeft';
import { FaAngleRight } from '@react-icons/all-files/fa/FaAngleRight';
import { Link } from 'gatsby';

import { createId } from '../../../../misc/utilities';

const itemStyle = {
	position: 'static',
	alignItems: 'stretch',
	'& > a, & > button': {
		position: 'relative',
		w: '100%',
		h: 'auto',
		p: '1.25rem',
		fontSize: '1.25rem',
		lineHeight: 1,
		_active: {
			bg: 'primary.500',
			color: 'white',
			_after: {
				display: 'none',
			},
		},
	},
	'&:not(:last-of-type) > a::after,&:not(:last-of-type) > button::after': {
		content: "''",
		position: 'absolute',
		bottom: 0,
		left: '1.25rem',
		w: 'calc(100% - 2.5rem)',
		borderBottom: '1px solid #dedede',
	},
	'& > a': {
		'& > svg': {
			float: 'right',
		},
	},
	'& > button': {
		display: 'flex',
		alignItems: 'flex-start',
		textAlign: 'left',
		bg: 'transparent',
		fontWeight: 600,
		'& > svg': {
			float: 'left',
			mr: '0.75rem',
		},
	},
	svg: {
		mt: '2px',
	},
};

const NavigationMobileItemWrapper = ({ children }) => (
	<Flex as="li" sx={itemStyle}>
		{children}
	</Flex>
);

export const NavigationMobileItem = ({ title, to, active, handleClick, children }) => {
	const hasSub = active !== undefined;
	const isExpanded = hasSub && !(children?.props?.display === 'none');

	const onClick = (e) => {
		if (!hasSub) return;
		e.preventDefault();
		handleClick();
	};

	return (
		<NavigationMobileItemWrapper>
			<Box
				as={Link}
				id={createId(to)}
				to={to}
				onClick={onClick}
				aria-haspopup={hasSub && 'true'}
				aria-expanded={isExpanded && 'true'}
				aria-controls={hasSub && `nav-${createId(to)}`}
			>
				{title}
				{hasSub && <FaAngleRight />}
			</Box>
			{children}
		</NavigationMobileItemWrapper>
	);
};

export const BackButton = ({ handleClick, children }) => (
	<NavigationMobileItemWrapper>
		<button onClick={handleClick}>
			<FaAngleLeft />
			{children}
		</button>
	</NavigationMobileItemWrapper>
);
